import type { KadeweUser } from "~/types";

export default defineNuxtRouteMiddleware((to) => {
    const user = useSanctumUser<KadeweUser>();
    const localePath = useLocalePath();

    if (!user.value?.email_verified_at && to.path !== localePath("/register/verify-email")) {
        console.warn("Verified: User is not verified but should be", to.path);
        return navigateTo(localePath("/register/verify-email"));
    }
});
